/**
 * useAdminMenuLayouts — lista layoutów admin scope (ADR-0034).
 *
 * GET /api/admin/menu/layouts zwraca metadata bez `hierarchy` (oszczędność na
 * dropdown). Pełny layout dociąga się przez fetch z `apiPrefix/layouts/:id`
 * w MenuBuilderShell.
 */

import type { AdminMenuLayoutSummary } from '@saas/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export const ADMIN_MENU_LAYOUTS_QUERY_KEY = ['admin', 'menu', 'layouts', 'list'] as const;

export interface AdminMenuLayoutsResponse {
  layouts: AdminMenuLayoutSummary[];
}

export function useAdminMenuLayouts(opts?: { enabled?: boolean }) {
  return useQuery<AdminMenuLayoutsResponse>({
    queryKey: ADMIN_MENU_LAYOUTS_QUERY_KEY,
    queryFn: async () => {
      const res = await api.get<AdminMenuLayoutsResponse>('/admin/menu/layouts');
      return res.data;
    },
    enabled: opts?.enabled ?? true,
    staleTime: 30_000,
  });
}
